// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Job-search-section {
    padding-left: 100px;
}

.Job-search-section .wrapper {
    padding-top: 50px;
    padding-bottom: 50px;
}


.Job-search-section .content-wrap .title {
    font-size: 46px;
    font-weight: 700;
    line-height: 58px;
    color: #242424;
    text-align: left;
    font-family: "Inter", sans-serif;
    letter-spacing: 0px;
    margin-top: 50px;
    font-family: "Inter", sans-serif;
}

.Job-search-section .content-wrap .title span {
    color: #ffffff;
    background-color: #9256E8;
    padding: 2px 6px;
}

.Job-search-section .content-wrap .description {
    font-size: 22px;
    line-height: 33px;
    font-weight: 400;
    color: #242424;
    margin: 24px 0px;
}

.Job-search-section .content-wrap .sub-description {
    color: #242424;
    font-weight: 700;
    line-height: 28px;
    font-size: 22px;
    padding-left: 5px;
    border-left: 5px solid #9256E8;
    font-family: "Inter", sans-serif;
}

.Job-search-section .content-wrap .download-btn {
    display: flex;
    margin-top: 24px;
}

.Job-search-section .content-wrap .download-btn .app-store {
    margin-right: 18px;
}

.Job-search-section .content-wrap .download-btn-mob {
    display: none;
}

@media (max-width: 768px) {
    .Job-search-section .wrapper {
        padding-top: 0px;
    }

    .Job-search-section {
        padding: 50px 25px;
    }

    .Job-search-section .content-wrap .title {
        font-size: 25px;
        line-height: 39px;
        margin-top: 0;
    }

    .Job-search-section .content-wrap .description {
        font-size: 15px;
        line-height: 19px;
        margin: 20px 0px;
        text-align: left;
    }

    .Job-search-section .content-wrap .sub-description {
        font-size: 15px;
        line-height: 33px;
    }

    .Job-search-section .right-img {
        margin-top: 40px;
    }

    .Job-search-section .content-wrap .download-btn {
        display: none;
    }

    .Job-search-section .content-wrap .download-btn-mob {
        display: block;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/JobSearch/JobSearch.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".Job-search-section {\n    padding-left: 100px;\n}\n\n.Job-search-section .wrapper {\n    padding-top: 50px;\n    padding-bottom: 50px;\n}\n\n\n.Job-search-section .content-wrap .title {\n    font-size: 46px;\n    font-weight: 700;\n    line-height: 58px;\n    color: #242424;\n    text-align: left;\n    font-family: \"Inter\", sans-serif;\n    letter-spacing: 0px;\n    margin-top: 50px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.Job-search-section .content-wrap .title span {\n    color: #ffffff;\n    background-color: #9256E8;\n    padding: 2px 6px;\n}\n\n.Job-search-section .content-wrap .description {\n    font-size: 22px;\n    line-height: 33px;\n    font-weight: 400;\n    color: #242424;\n    margin: 24px 0px;\n}\n\n.Job-search-section .content-wrap .sub-description {\n    color: #242424;\n    font-weight: 700;\n    line-height: 28px;\n    font-size: 22px;\n    padding-left: 5px;\n    border-left: 5px solid #9256E8;\n    font-family: \"Inter\", sans-serif;\n}\n\n.Job-search-section .content-wrap .download-btn {\n    display: flex;\n    margin-top: 24px;\n}\n\n.Job-search-section .content-wrap .download-btn .app-store {\n    margin-right: 18px;\n}\n\n.Job-search-section .content-wrap .download-btn-mob {\n    display: none;\n}\n\n@media (max-width: 768px) {\n    .Job-search-section .wrapper {\n        padding-top: 0px;\n    }\n\n    .Job-search-section {\n        padding: 50px 25px;\n    }\n\n    .Job-search-section .content-wrap .title {\n        font-size: 25px;\n        line-height: 39px;\n        margin-top: 0;\n    }\n\n    .Job-search-section .content-wrap .description {\n        font-size: 15px;\n        line-height: 19px;\n        margin: 20px 0px;\n        text-align: left;\n    }\n\n    .Job-search-section .content-wrap .sub-description {\n        font-size: 15px;\n        line-height: 33px;\n    }\n\n    .Job-search-section .right-img {\n        margin-top: 40px;\n    }\n\n    .Job-search-section .content-wrap .download-btn {\n        display: none;\n    }\n\n    .Job-search-section .content-wrap .download-btn-mob {\n        display: block;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
